import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { ReactComponent as Logo } from "assets/images/onstreet.svg";
import ContentContainer from "components/ContentContainer";
import { ExtraPaddingProps } from "components/PopupsFullPageContainer";
import styled from "styled-components";
import {
  appearFromBottom,
  defaultAnimationDelay,
  defaultAnimationDuration,
} from "theme/animations";
import {
  DEMONSTRATION_ANIMATION_DURATION,
  headerPadding,
} from "configs/general";

interface ContainerProps extends Omit<ExtraPaddingProps, "extraPaddingTop"> {
  isOpen: boolean;
  isSmallPaddingAnimationVersion: boolean;
  popupsHeight: number;
}

export const Container = styled.div<ContainerProps>`
  overflow: hidden;
  z-index: 1004;
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  left: 0;
  bottom: ${({ isSmallPaddingAnimationVersion, popupsHeight, isOpen }) =>
    isSmallPaddingAnimationVersion && !isOpen ? `${popupsHeight}px` : 0};
  width: ${({ isOpen }) => (isOpen ? "100vw" : "165px")};
  height: ${({ isOpen }) => (isOpen ? "100vh" : "140px")};
  background-color: ${({ theme }) => theme.colors.light};
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.3);
  transition: ${DEMONSTRATION_ANIMATION_DURATION},
    top
      ${({ extraPaddingTopAnimationDuration }) =>
        extraPaddingTopAnimationDuration}s,
    bottom
      ${({ extraPaddingTopAnimationDuration }) =>
        extraPaddingTopAnimationDuration}s;

  animation: ${appearFromBottom} ${defaultAnimationDuration}s;
  animation-delay: ${defaultAnimationDelay}s;
  animation-fill-mode: both;

  .closed-content {
    opacity: ${({ isOpen }) => (isOpen ? 0 : 1)};
    transition: opacity ${DEMONSTRATION_ANIMATION_DURATION};
  }

  .open-content {
    opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
    transition: opacity ${DEMONSTRATION_ANIMATION_DURATION};
    pointer-events: ${({ isOpen }) => (isOpen ? "all" : "none")};
  }
`;

export const StyledContentContainer = styled(ContentContainer)`
  height: 100%;
  display: flex;
  justify-content: center;
`;

export const TopContainer = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
  cursor: pointer;

  svg {
    margin-top: 10px;
    width: 60%;
  }
`;

export const OpenContentContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
`;

export const StyledLogo = styled(Logo)`
  position: absolute;
  top: ${headerPadding.top.md};
  left: ${headerPadding.horizontal.lg};
`;

export const StyledCloseIcon = styled(CloseIcon)`
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
`;

export const ImageContainer = styled.div`
  width: 35vw;
  max-width: 200px;
  margin: 10vh auto 10vh;
`;
